import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const TALLY_URL = 'https://tally.so/r/Ek57zL';
export function WaitlistCTA() {
  return <section className="relative overflow-hidden bg-[#0F1B2D] py-24" data-id="element-131">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F1B2D] to-[#0A1220]" data-id="element-132" />
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-133" />

      {/* Animated Background Orbs */}
      <motion.div animate={{
      scale: [1, 1.2, 1],
      opacity: [0.1, 0.2, 0.1]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-0 left-1/4 w-96 h-96 bg-[#E8531E]/10 rounded-full blur-[100px]" data-id="element-134" />
      <motion.div animate={{
      scale: [1, 1.3, 1],
      opacity: [0.05, 0.15, 0.05]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute bottom-0 right-1/4 w-80 h-80 bg-blue-500/10 rounded-full blur-[80px]" data-id="element-135" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="mx-auto max-w-3xl" data-id="element-137">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6" data-id="element-138">
            Be the First to Know When We Launch
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-lg text-slate-400 mb-10 max-w-2xl mx-auto" data-id="element-139">
            Join thousands of Nigerians in the diaspora who are ready to invest
            in property back home securely and transparently.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-140">
            <a href={TALLY_URL} target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center rounded-lg bg-[#E8531E] text-white hover:bg-[#CC4A15] font-semibold h-14 px-8 text-lg transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E8531E] shadow-lg shadow-orange-900/20 hover:scale-105 active:scale-95 overflow-hidden group" data-id="element-141">
              <span className="relative z-10 flex items-center" data-id="element-142">
                Join the Waitlist{' '}
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-143" />
              </span>
              <motion.div className="absolute inset-0 bg-white/20" initial={{
              x: '-100%'
            }} whileHover={{
              x: '100%'
            }} transition={{
              duration: 0.5
            }} data-id="element-144" />
            </a>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="mt-4 text-xs text-slate-500" data-id="element-145">
            No spam, ever. Unsubscribe anytime.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}